module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VG0003-2833d99c4707e0b05b7359b7b3da02d9.png";